import { actionCreatorFactory } from "typescript-fsa";
import { userdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("Watchdogtable");

 const resetData = actionCreator<{data:userdata[]}>("WATCHDOGTABLE_RESETDATA");

 export const TableThingyActions = { resetData}


